import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import InteralizingExternalities from './internalizing-externalities';
import FiveFoundations from './five-foundations';
import InterestOnReserves from './supply-demand-equilibrium';
import ProductionFunction from './production-function';
import ProfitMaximization from './profit-maximization';
import ElasticityOfDemand from './elasticity';
import Ch6InterestOnReserves from './price-controls';
import PriceDiscrimination from './price-discrimination';
import StrategicBehavior from './strategic-behavior';
import ComponentsGDP from './components-gdp';
import Bonds from './bonds';
import ShortRunAggregateSupply from './aggregate-demand-supply';
import LongRun from './monetary-policy';
import { Route } from "react-router-dom"
import reportWebVitals from './reportWebVitals';
import { InteractiveRouting } from '@bittnerdevelopmentgroup/interactive-builder'

console.log("process.env.REACT_APP_CLOUDFRONT_URL", process.env.REACT_APP_CLOUDFRONT_URL)
console.log("process.env.REACT_APP_PAGES_URL", process.env.REACT_APP_PAGES_URL)
console.log("process.env.REACT_APP_PROJECT_TITLE", process.env.REACT_APP_PROJECT_TITLE)


const root = ReactDOM.createRoot(
  document.getElementById('root')
);

if (document.location.hostname === "localhost" || document.location.hostname === "127.0.0.1") {
  root.render(
    <InteractiveRouting
      title={process.env.REACT_APP_PROJECT_TITLE}
      cloudfrontUrl={process.env.REACT_APP_CLOUDFRONT_URL}
      pagesUrl={process.env.REACT_APP_PAGES_URL}
      additionalPages={[
        { title: "Demo", urlSlug: "/app-demo" },
        { title: "Price Discrimination in Practice", urlSlug: "/chapter-1" },
        { title: "Supply, Demand, and Equilibrium", urlSlug: "/chapter-3" },
        { title: "Price Elasticity of Demand and Consumer Sensitivity", urlSlug: "/chapter-4b" },
        { title: "Price Controls and Market Outcomes", urlSlug: "/chapter-6" },
        { title: "Economic Intuition Interactive: Internalizing Externalities", urlSlug: "/chapter-7a" },
        { title: "Diminishing Marginal Product of Labor", urlSlug: "/chapter-8b" },
        { title: "Maximizing Profits in a Competitive Market", urlSlug: "/chapter-9a" },
        { title: "Price Discrimination in Practice", urlSlug: "/chapter-11" },
        { title: "Game Theory and Strategic Behavior", urlSlug: "/chapter-13" },
        { title: "Components of GDP", urlSlug: "/chapter-19b" },
        { title: "Bonds: Interest and Risk", urlSlug: "/chapter-23" },
        { title: "Aggregate Supply: Prices in the Short Run", urlSlug: "/chapter-26" },
        { title: "Monetary Policy in the Short Run and Long Run", urlSlug: "/chapter-31b" },
      ]}
    >
      <Route path="/app-demo" element={<App />} />
      <Route path="/chapter-1" element={<FiveFoundations />} />
      <Route path="/chapter-3" element={<InterestOnReserves />} />
      <Route path="/chapter-4b" element={<ElasticityOfDemand />} />
      <Route path="/chapter-6" element={<Ch6InterestOnReserves />} />
      <Route path="/chapter-7a" element={<InteralizingExternalities />} />
      <Route path="/chapter-8b" element={<ProductionFunction />} />
      <Route path="/chapter-9a" element={<ProfitMaximization />} />
      <Route path="/chapter-11" element={<PriceDiscrimination />} />
      <Route path="/chapter-13" element={<StrategicBehavior />} />
      <Route path="/chapter-19b" element={<ComponentsGDP />} />
      <Route path="/chapter-23" element={<Bonds />} />
      <Route path="/chapter-26" element={<ShortRunAggregateSupply />} />
      <Route path="/chapter-31b" element={<LongRun />} />
    </InteractiveRouting>
  );
} else {
  root.render(
    <React.StrictMode>
      <InteractiveRouting
        title={process.env.REACT_APP_PROJECT_TITLE}
        cloudfrontUrl={process.env.REACT_APP_CLOUDFRONT_URL}
        pagesUrl={process.env.REACT_APP_PAGES_URL}
        additionalPages={[
          { title: "Demo", urlSlug: "/app-demo" },
          { title: "Price Discrimination in Practice", urlSlug: "/chapter-1" },
          { title: "Supply, Demand, and Equilibrium", urlSlug: "/chapter-3" },
          { title: "Price Elasticity of Demand and Consumer Sensitivity", urlSlug: "/chapter-4b" },
          { title: "Price Controls and Market Outcomes", urlSlug: "/chapter-6" },
          { title: "Economic Intuition Interactive: Internalizing Externalities", urlSlug: "/chapter-7a" },
          { title: "Diminishing Marginal Product of Labor", urlSlug: "/chapter-8b" },
          { title: "Maximizing Profits in a Competitive Market", urlSlug: "/chapter-9a" },
          { title: "Price Discrimination in Practice", urlSlug: "/chapter-11" },
          { title: "Game Theory and Strategic Behavior", urlSlug: "/chapter-13" },
          { title: "Components of GDP", urlSlug: "/chapter-19b" },
          { title: "Bonds: Interest and Risk", urlSlug: "/chapter-23" },
          { title: "Aggregate Supply: Prices in the Short Run", urlSlug: "/chapter-26" },
          { title: "Monetary Policy in the Short Run and Long Run", urlSlug: "/chapter-31b" },
        ]}
      >
        <Route path="/app-demo" element={<App />} />
        <Route path="/chapter-1" element={<FiveFoundations />} />
        <Route path="/chapter-3" element={<InterestOnReserves />} />
        <Route path="/chapter-4b" element={<ElasticityOfDemand />} />
        <Route path="/chapter-6" element={<Ch6InterestOnReserves />} />
        <Route path="/chapter-7a" element={<InteralizingExternalities />} />
        <Route path="/chapter-8b" element={<ProductionFunction />} />
        <Route path="/chapter-9a" element={<ProfitMaximization />} />
        <Route path="/chapter-11" element={<PriceDiscrimination />} />
        <Route path="/chapter-13" element={<StrategicBehavior />} />
        <Route path="/chapter-19b" element={<ComponentsGDP />} />
        <Route path="/chapter-23" element={<Bonds />} />
        <Route path="/chapter-26" element={<ShortRunAggregateSupply />} />
        <Route path="/chapter-31b" element={<LongRun />} />
      </InteractiveRouting>
    </React.StrictMode>
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
